import React, { useState } from "react";
import { useProfilePassChangeMutation } from "../../redux/profileApi";
import { toast, ToastContainer } from "react-toastify";

function ChangePassword() {
  const [profilePassChange, { isLoading }] = useProfilePassChangeMutation();
  const [btnDisabled, setBtnDisabled] = useState(false)
  const [pass, setPass] = useState({
    oldPass: "",
    newPass: "",
    conPass: "",
  });

  const [errors, setErrors] = useState({
    oldPass: "",
    newPass: "",
    conPass: "",
  });

  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  // 👁️‍🗨️ Toggle input type
  const togglePassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&/#^()+={}[\]\\|:;'"<>,.~`_-])[A-Za-z\d@$!%*?&/#^()+={}[\]\\|:;'"<>,.~`_-]{8,}$/;

  // 📝 Handle input change and live validation
  const handleChange = (e) => {
    const { name, value } = e.target;

    setPass((prev) => ({ ...prev, [name]: value }));

    if (value.trim() === "") {
      setErrors((prev) => ({ ...prev, [name]: "This field is required" }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    // ✅ Password strength check
    if (name === "newPass" && value && !strongPasswordRegex.test(value)) {
      setErrors((prev) => ({
        ...prev,
        newPass:
          "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character",
      }));
    }

    // ✅ Check confirm password mismatch in both cases:
    if (
      (name === "conPass" && value !== pass.newPass) || // typing in confirm
      (name === "newPass" && pass.conPass && pass.conPass !== value) // typing in new
    ) {
      setErrors((prev) => ({ ...prev, conPass: "Passwords do not match" }));
    } else if (
      (name === "conPass" && value === pass.newPass) ||
      (name === "newPass" && pass.conPass === value)
    ) {
      setErrors((prev) => ({ ...prev, conPass: "" }));
    }
    if (name === "conPass" && !value.trim()) {
      setErrors((prev) => ({ ...prev, conPass: "This field is required" }));
    }
  };

  // ✅ Validate before API call
  const validateForm = () => {
    const { oldPass, newPass, conPass } = pass;
    let valid = true;
    let errorObj = { oldPass: "", newPass: "", conPass: "" };

    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&/#^()+={}[\]\\|:;'"<>,.~`_-])[A-Za-z\d@$!%*?&/#^()+={}[\]\\|:;'"<>,.~`_-]{8,}$/;

    if (!oldPass.trim()) {
      errorObj.oldPass = "This field is required";
      valid = false;
    }

    if (!newPass.trim()) {
      errorObj.newPass = "This field is required";
      valid = false;
    } else if (!strongPasswordRegex.test(newPass)) {
      errorObj.newPass =
        "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character";
      valid = false;
    }

    if (!conPass.trim()) {
      errorObj.conPass = "This field is required";
      valid = false;
    } else if (newPass !== conPass) {
      errorObj.conPass = "Passwords do not match";
      valid = false;
    }

    setErrors(errorObj);
    return valid;
  };

  // 🔐 Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setBtnDisabled(true)
    setTimeout(()=>setBtnDisabled(false),3000)

    const payload = {
      oldPassword: pass.oldPass,
      newPassword: pass.conPass,
    };

    const res = await profilePassChange(payload);
    const { data, error } = res;

    if (data?.status) {
      toast.dismiss();
      toast.success(data.message || "Password changed successfully");
      setPass({ oldPass: "", newPass: "", conPass: "" });
      const theme = localStorage.getItem("theme");
      localStorage.clear();
      localStorage.setItem("theme", theme);
      setTimeout(() => (window.location.href = "login"), 1000);
    } else {
      toast.error(error?.data?.message || "Failed to change password");
    }
  };

  return (
    <div className="col-lg-4 mb-3">
      <div className="white_box h_100 mb-0">
        <h5>Change Password</h5>
        <div className="bank-info info-main-outer mt-2">
          <form onSubmit={handleSubmit}>
            <div className="form-group eye_pass eye_pass_two">
              <label>Old Password</label>
              <input
                className="form-control"
                type={showPassword.old ? "text" : "password"}
                name="oldPass"
                maxLength={30}
                onChange={handleChange}
                value={pass.oldPass}
                placeholder="Enter Old Password"
              />
              <span
                className="password__show eye1"
                onClick={() => togglePassword("old")}
              >
                {showPassword.old ? (
                  <i className="las la-eye"></i>
                ) : (
                  <i className="las la-low-vision"></i>
                )}
              </span>
              <div style={{ color: "red" }}>{errors.oldPass}</div>
            </div>

            <div className="form-group eye_pass eye_pass_two">
              <label>New Password</label>
              <input
                type={showPassword.new ? "text" : "password"}
                className="form-control"
                name="newPass"
                maxLength={30}
                value={pass.newPass}
                onChange={handleChange}
                placeholder="Enter New Password"
              />
              <span
                className="password__show eye1"
                onClick={() => togglePassword("new")}
              >
                {showPassword.new ? (
                  <i className="las la-eye"></i>
                ) : (
                  <i className="las la-low-vision"></i>
                )}
              </span>
              <div style={{ color: "red" }}>{errors.newPass}</div>
            </div>

            <div className="form-group eye_pass eye_pass_two">
              <label>Confirm New Password</label>
              <input
                type={showPassword.confirm ? "text" : "password"}
                className="form-control"
                name="conPass"
                maxLength={30}
                value={pass.conPass}
                onChange={handleChange}
                placeholder="Enter Confirm Password"
              />
              <span
                className="password__show eye1"
                onClick={() => togglePassword("confirm")}
              >
                {showPassword.confirm ? (
                  <i className="las la-eye"></i>
                ) : (
                  <i className="las la-low-vision"></i>
                )}
              </span>
              <div style={{ color: "red" }}>{errors.conPass}</div>
            </div>

            <div className="form-group text-end">
              <button className="btn btn_man fs14" disabled={isLoading || btnDisabled}>
                {isLoading || btnDisabled ? "Updating..." : "Change Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
